import { ArrowUpRight, Envelope, MapPin, Phone } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { business, services } from '../content/site';
import { getFooterServices } from '../lib/serviceDisplay';
import { BrandMark } from './BrandMark';

export function Footer() {
  const footerServices = getFooterServices(services);

  return (
    <footer className="site-footer">
      <div className="site-footer__lead">
        <BrandMark footer />
        <div>
          <h2>Ready to improve the property?</h2>
          <p>Share the location, the work you have in mind, and any photos or details that can help start the conversation.</p>
        </div>
        <Link className="button button--primary" to="/contact">Request an Estimate <ArrowUpRight aria-hidden="true" size={18} /></Link>
      </div>
      <div className="site-footer__grid">
        <div className="footer-contact">
          <h3>Contact</h3>
          <a href={business.phoneHref}><Phone aria-hidden="true" size={18} weight="fill" /> {business.phoneDisplay}</a>
          <a href={business.emailHref}><Envelope aria-hidden="true" size={18} /> {business.email}</a>
          <span><MapPin aria-hidden="true" size={18} /> Based in {business.base}</span>
        </div>
        <div>
          <h3>Services</h3>
          <ul>
            {footerServices.map((service) => <li key={service.slug}><Link to={`/${service.slug}`}>{service.navName}</Link></li>)}
          </ul>
        </div>
        <div>
          <h3>Explore</h3>
          <ul>
            <li><Link to="/projects">Projects</Link></li>
            <li><Link to="/service-area">Service Area</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/guides">Guides</Link></li>
            <li><Link to="/privacy">Privacy</Link></li>
          </ul>
        </div>
      </div>
      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} {business.name}</span>
        <span className="site-footer__summary">Hardscapes, masonry, tile, concrete, grading, and drainage across Eastern North Carolina.</span>
        <a className="site-footer__credit" href="https://wademedia.biz">Website design and development by Wade Media</a>
      </div>
    </footer>
  );
}
